import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as IconFilter } from '../../../assets/icon/ic_filter.svg';
import ButtonTypes from '../../../constants/buttonTypes';
import UserLogFilterMenu from './UserLogFilterMenu';
import CustomDropdownMenu from '../../../components/CustomDropdownMenu/CustomDropdownMenu';

const UserLogCardHeader = ({ onReset, showUserFilter }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  return (
    <CustomDropdownMenu
      Icon={IconFilter}
      btnText="Filter"
      drop="up"
      btnType={ButtonTypes.LIGHT_PRIMARY}
      headerText="Filter Options"
      visible={menuVisible}
      toggleVisible={setMenuVisible}
    >
      <UserLogFilterMenu onReset={onReset} showUserFilter={showUserFilter} />
    </CustomDropdownMenu>
  );
};

UserLogCardHeader.propTypes = {
  onReset: PropTypes.func,
  showUserFilter: PropTypes.bool
};

UserLogCardHeader.defaultProps = {
  onReset: () => {},
  showUserFilter: true
};

export default UserLogCardHeader;
